<template>
  <component-wrapper class="data-privacy-fi">
    <experience-editor-component
      v-if="isEditMode"
      :fields="fields"
    />

    <template v-else-if="!isLoading">
      <grid-container-fi v-if="dataPrivacyHTML">
        <div
          class="fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-12 lg:fi-col-start-3 lg:fi-col-end-11"
        >
          <richtext-fi>
            <!-- eslint-disable vue/no-v-html -->
            <div
              class="data-privacy-fi__content"
              v-html="dataPrivacyHTML"
            />
            <!-- eslint-enable vue/no-v-html -->
          </richtext-fi>
        </div>
      </grid-container-fi>
    </template>

    <loading-indicator
      v-else
      variant="spinnerLocal"
    />
  </component-wrapper>
</template>

<script>
import { LoadingIndicator, RichtextFi } from 'atoms';
import axios from 'axios';
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import GridContainerFi from 'components/grid-fi/GridContainerFi';
import { defineAsyncComponent } from 'vue';

const ExperienceEditorComponent = defineAsyncComponent(
  () => import('atoms/experience-editor-component/ExperienceEditorComponent'),
);

export default {
  name: 'DataPrivacyFi',
  components: {
    ComponentWrapper,
    GridContainerFi,
    LoadingIndicator,
    RichtextFi,
    ExperienceEditorComponent,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isLoading: true,
      dataPrivacyHTML: null,
      jumpmarkReady: null,
    };
  },
  computed: {
    documentId() {
      return this.fields?.documentId?.value;
    },
  },
  mounted() {
    if (this.documentId && !this.isEditMode) {
      this.jumpmarkReady = this.loadData();
    } else {
      console.error('missing documentId for data privacy api');
    }
  },
  methods: {
    async loadData() {
      try {
        const response = await axios.get(
          `https://api.fischer.group/privacy-policies/${this.documentId}`,
        );

        if (response.data) {
          this.dataPrivacyHTML = response.data.replace('<h2>', '<h1>').replace('</h2>', '</h1>');
        }
      } catch (error) {
        console.error(error);
      }

      this.isLoading = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import './data-privacy-fi';
</style>
